import Layout from 'src/views/components/layout/'

function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/main/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'main')
    }
}

let routes = {
    path: '/',
    hide: true,
    redirect: '/account/survey',
    component: Layout,
    meta: {
        title: ''
    },
    children: [
        {
            name: 'error404',
            path: 'error404',
            meta: {
                title: '404',
                mode: 'public'
            }
        },
        {
            name: 'login',
            path: 'login',
            meta: {
                title: '用户登录',
                mode: 'public'
            }
        },
        {
            name: 'registry',
            path: 'registry',
            meta: {
                title: '注册',
                mode: 'public'
            }
        },
        {
            name: 'forget-password',
            path: 'forget-password',
            meta: {
                title: '忘记密码',
                mode: 'public'
            }
        },
        {
            name: 'protocol',
            path: 'protocol',
            meta: {
                title: '隐私政策',
                mode: 'public'
            }
        },
        {
            name: 'privacy',
            path: 'privacy',
            meta: {
                title: '服务协议',
                mode: 'public'
            }
        },
        {
            name: 'un-active',
            path: 'un-active',
            meta: {
                title: '未激活',
                mode: 'public'
            }
        },
        {
            name: 'un-active-forgot',
            path: 'un-active-forgot',
            meta: {
                title: '找回密码-未激活',
                mode: 'public'
            }
        },
        {
            name: 'success',
            path: 'success',
            meta: {
                title: '成功',
                mode: 'public'
            }
        },
        {
            name: 'bind-success',
            path: 'bind-success',
            meta: {
                title: '成功',
                mode: 'public'
            }
        },
        {
            name: 'activation',
            path: 'activation',
            meta: {
                title: '注册成功',
                mode: 'public'
            }
        }
    ]
}

routes.children.forEach((v) => {
    if (!v.redirect && !v.component) {
        const router = v.meta.mode || 'default'
        v.components = {
            [router]: getView(v.name, v.meta.title)
        }
    }
})

export default [routes]



// WEBPACK FOOTER //
// ./src/router/modules/main.js